import { Button, Paper, Typography } from '@lingoda/ui';
import { Grid } from '@lingoda/ui/layout/GridNext';
import { trans } from '@lingoda/i18n';
interface PauseRolloverSubscriptionBannerProps {
    onClick: () => void;
}
export const PauseRolloverSubscriptionBanner = ({
    onClick,
}: PauseRolloverSubscriptionBannerProps) => {
    return (
        <Paper
            variant="outlined"
            sx={(theme) => ({
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.common.white,
                border: '1px solid',
                borderColor: 'divider',
            })}
        >
            <Grid container p={3}>
                <Grid sm={12} md={10}>
                    <Typography variant="h3" mb={1}>
                        {trans('rollover-pause-take-a-break-banner-title', {}, 'student-common')}
                    </Typography>
                    <Typography variant="body2" mb={3} htmlColor="text.secondary">
                        {trans('rollover-pause-take-a-break-banner-content', {}, 'student-common')}
                    </Typography>
                    <Button color="primary" variant="contained" onClick={onClick}>
                        {trans('rollover-pause-next-subscription-btn', {}, 'student-common')}
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    );
};
